import Seo from "../components/Seo";
import { PageHero } from "../components/common";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    label: "Legal",
    intro: "This placeholder Privacy Policy describes, in general terms, how STERILTRON handles information submitted through steriltron.com. Final legal text will be provided by STERILTRON.",
    sections: [
      ["Information We Collect", "We collect the information you voluntarily provide through our contact form, such as your name, company, country, email, phone number and message."],
      ["How We Use Information", "Submitted information is used solely to respond to your enquiry and to provide the engineering and commercial support you request."],
      ["Data Retention", "Contact enquiries are retained only as long as necessary to handle your request and to maintain a record of our correspondence."],
      ["Your Rights", "You may request access to, correction of, or deletion of your personal data by contacting us at info@steriltron.com."],
    ],
  },
  cookies: {
    title: "Cookie Policy",
    label: "Legal",
    intro: "This placeholder Cookie Policy explains, in general terms, how steriltron.com uses cookies. Final legal text will be provided by STERILTRON.",
    sections: [
      ["What Are Cookies", "Cookies are small text files stored on your device that help websites function and understand how they are used."],
      ["How We Use Cookies", "We may use essential cookies for site functionality and, with consent, analytics cookies to improve the experience."],
      ["Managing Cookies", "You can control or delete cookies through your browser settings at any time."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    label: "Legal",
    intro: "These placeholder Terms & Conditions govern the general use of steriltron.com. Final legal text will be provided by STERILTRON.",
    sections: [
      ["Use of the Website", "The content on this website is provided for general information about STERILTRON products and solutions."],
      ["Intellectual Property", "All content, branding and imagery on this website are the property of STERILTRON and may not be reproduced without permission."],
      ["Product Information", "Technical specifications are indicative and subject to change; binding specifications are confirmed per project."],
      ["Contact", "For any questions regarding these terms, contact us at info@steriltron.com."],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <>
      <Seo title={`${c.title} | STERILTRON`} description={c.intro} path={`/${type}`} />
      <PageHero label={c.label} titleLines={[c.title]} description={c.intro} />
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12 space-y-10">
          {c.sections.map(([h, b], i) => (
            <div key={h}>
              <h2 className="font-heading text-2xl font-semibold tracking-tight text-brand-950">{`${i + 1}. ${h}`}</h2>
              <p className="mt-3 text-slate-700 leading-relaxed">{b}</p>
            </div>
          ))}
          <p className="text-sm text-slate-400 pt-6 border-t border-slate-200">Last updated: 2026 — Placeholder content.</p>
        </div>
      </section>
    </>
  );
}
